var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.id && _vm.$can('read', 'Player'))?_c('router-link',{attrs:{"to":{
    name: 'player.report',
    params: { id: _vm.id, context: _vm.context, reportType: _vm.reportType },
  }}},[_vm._t("default")],2):_c('span',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }